import { Stack, StackProps } from '@chakra-ui/react'
import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'

const motionProps = {
  variants: {
    hidden: {
      opacity: 0,
      y: '50%',
    },
    visible: {
      opacity: 1,
      y: '0%',
    },
  },
}

export interface AnimatedListProps {
  wrapper?: React.FC<unknown>
}

export const Delay: React.FC<{
  delay: number
  motionProps: Record<string, unknown>
}> = ({ children, delay, motionProps }) => {
  const [done, setDone] = useState(false)

  useEffect(() => {
    const showTimer = setTimeout(() => setDone(true), delay)
    return () => clearTimeout(showTimer)
  })

  return (
    <motion.div
      {...motionProps}
      animate={done ? 'visible' : 'hidden'}
      style={{ visibility: done ? 'visible' : 'hidden' }}
    >
      {children}
    </motion.div>
  )
}

const DefaultWrapper: React.FC = ({ children }) => <>{children}</>

export const StackWrapper: React.FC<StackProps> = props => (
  <Stack spacing={5} {...props} />
)

export const AnimatedList: React.FC<AnimatedListProps> = ({
  children,
  wrapper = DefaultWrapper,
}) => {
  const Wrapper = wrapper
  return (
    <AnimatePresence>
      <Wrapper>
        {React.Children.map(children, (child, i) => (
          <Delay key={i} delay={i * 50} motionProps={motionProps}>
            {child}
          </Delay>
        ))}
      </Wrapper>
    </AnimatePresence>
  )
}
